<template>
  <div
    :class="
      twMerge(
        'overflow-hidden bg-[linear-gradient(95.01deg,#BDB1FF_2.72%,#6952ED_95.35%)] rounded-full p-px max-w-max tracking-wider	',
        props.outlined && 'bg-none',
        props.containerClass
      )
    "
  >
    <!-- NuxtLink when link is passed -->
    <NuxtLink
      v-if="link"
      :to="link"
      v-bind="$attrs"
      :class="
        twMerge(
          'h-full px-4 lg:px-5 py-1.5 lg:py-2.5 rounded-full border-0 bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] text-white inline-flex items-center justify-center',
          props.outlined && 'bg-none text-foreground',
          props.appendClass
        )
      "
    >
      <slot>Button</slot>
    </NuxtLink>

    <!-- Default Button otherwise -->
    <Button
      v-else
      unstyled
      size="small"
      v-bind="$attrs"
      :class="
        twMerge(
          'h-full px-4 lg:px-5 py-1.5 lg:py-2.5 rounded-full border-0 bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] text-white',
          props.outlined && 'bg-none text-foreground',
          props.appendClass
        )
      "
    >
      <slot>Button</slot>
    </Button>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

type Props = {
  appendClass?: string;
  containerClass?: string;
  outlined?: boolean;
  link?: string;
};

const props = withDefaults(defineProps<Props>(), {});
</script>
